export default __webpack_public_path__ + "static/media/premium@3x.65a73d89.png";